import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Pack\DeletePackController::deleteMethod
* @see app/Http/Controllers/Pack/DeletePackController.php
* @route '/api/pack/pack-delete/{pack}'
*/
export const deleteMethod = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/pack/pack-delete/{pack}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Pack\DeletePackController::deleteMethod
* @see app/Http/Controllers/Pack/DeletePackController.php
* @route '/api/pack/pack-delete/{pack}'
*/
deleteMethod.url = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { pack: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { pack: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            pack: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        pack: typeof args.pack === 'object'
        ? args.pack.id
        : args.pack,
    }

    return deleteMethod.definition.url
            .replace('{pack}', parsedArgs.pack.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Pack\DeletePackController::deleteMethod
* @see app/Http/Controllers/Pack/DeletePackController.php
* @route '/api/pack/pack-delete/{pack}'
*/
deleteMethod.delete = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Pack\DeletePackController::undo
* @see app/Http/Controllers/Pack/DeletePackController.php
* @route '/api/pack/undo-delete/{id}'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/pack/undo-delete/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Pack\DeletePackController::undo
* @see app/Http/Controllers/Pack/DeletePackController.php
* @route '/api/pack/undo-delete/{id}'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Pack\DeletePackController::undo
* @see app/Http/Controllers/Pack/DeletePackController.php
* @route '/api/pack/undo-delete/{id}'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Pack\DeletePackController::undo
* @see app/Http/Controllers/Pack/DeletePackController.php
* @route '/api/pack/undo-delete/{id}'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeletePackController = { deleteMethod, undo, delete: deleteMethod }

export default DeletePackController